export interface BankPaymentMethod extends PaymentMethod {

}

export enum CardBrand {
    AMEX = 'AMEX',
    DINERS_CLUB = 'DINERS_CLUB',
    DISCOVER = 'DISCOVER',
    JCB = 'JCB',
    MASTERCARD = 'MASTERCARD',
    UNION_PAY = 'UNION_PAY',
    VISA = 'VISA',
}

export interface CardPaymentMethod extends PaymentMethod {
    cardBrand: CardBrand
    cardLast4: string
    expiration: string
}

export enum PaymentMethodType {
    BANK = 'BANK',
    CARD = 'CARD',
}

export interface PaymentMethod {
    id?: string
    status?: string
    statusReasons?: Array<string>
    type: PaymentMethodType
}